export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-8843d53cd04b7761de647123f08da5ea.jpg";